module.exports = __webpack_public_path__ + "img/imitate_icon.3bdce4ed.png";